import Vue from "vue";

/* eslint-disable */
class AppCrud {
  constructor(entityName, eagerload, action, url, append) {
    this.entityName = entityName;
    this.eagerload = Array.isArray(eagerload) ? eagerload.join(';') : eagerload;
    this.data = [];
    this.append = append || '';

    if (action) {
      this.action = action;
    } else {
      this.action = Vue.router.currentRoute.name.split('.')[1];
    }

    if (url) {
      this.url = url;
    } else {
      this.url = `/${window.pluralize(this.entityName)}`;
    }
  }

  initFormData(form, id) {
    if (!id) {
      id = Vue.router.currentRoute.params.id;
    }

    if (this.getAction() === 'edit') {
      return new Promise((resolve, reject) => {
        form.startProcessing();

        const eager = this.eagerload ? `?with=${this.eagerload}` : '';

        Vue.http.get(`${this.url}/${id}/${eager}${this.append}`)
          .then((response) => {
            this.data = response.body;

            form.loadData(this.data);
            form.finishProcessing();

            resolve(response);
          })
          .catch((response) => {
            form.finishProcessing();

            reject(response);
          });
      });
    } else {
      return new Promise((resolve, reject) => {
        resolve();
      });
    }
  }

  submit(form, action, id) {
    if (!action) {
      action = this.getAction();
    }

    switch (action) {
      case 'create':
        return new Promise((resolve, reject) => {
          form.startProcessing();

          form.post(this.url)
            .then((response) => {
              form.finishProcessing();
              resolve(response);
            })
            .catch((response) => {
              form.finishProcessing();
              reject(response);
            });
        });

      case 'edit':
        return new Promise((resolve, reject) => {
          form.startProcessing();

          if (!id) {
            id = Vue.router.currentRoute.params.id;
          }

          form.put(`${this.url}/${id}`)
            .then((response) => {
              form.finishProcessing();
              resolve(response);
            })
            .catch((response) => {
              form.finishProcessing();
              reject(response);
            });
        });

      case 'upload':
        return new Promise((resolve, reject) => {
          form.startProcessing();

          form.upload(this.url)
            .then((response) => {
              form.finishProcessing();
              resolve(response);
            })
            .catch((response) => {
              form.finishProcessing();
              reject(response);
            });
        });

      default:
    }
  }

  getAction() {
    return this.action;
  }
}

export default AppCrud;
